import React from "react";
import "../../InvoicingIATA.css";
import {
  formatToPositiveValue,
  handleEmptyValue,
} from "../../../../../utils/utils";
import { DATE_FORMAT } from "../../../../../utils/constants";
import dayjs from "dayjs";

const InvoicingIATAPaymentRecieptTable = ({ invoicingData }) => {
  return (
    <div className="invoicing-IATA-table-parent-container">
      <div className="invoicing-IATA-table-container">
        <table className="invoicing-IATA-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Account</th>
              <th>Material Desc No.</th>
              <th>Account Code</th>
              <th>Related Doc No</th>
              <th>Airline Name</th>
              <th>Reference</th>
              <th>Posting Date</th>
              <th>Payment Method</th>
              <th>Document Amount</th>
              <th>Billing Doc Type</th>
              <th>Client Invoice Ref</th>
              <th>Clearing Status</th>
              <th>File Name</th>
            </tr>
          </thead>
          <tbody>
            <tr key={1}>
              <td>{1}</td>
              <td>{handleEmptyValue(invoicingData?.clientAccountNumber)}</td>
              <td>{handleEmptyValue(invoicingData?.materialLoan)}</td>
              <td>{handleEmptyValue(invoicingData?.accountCode)}</td>
              <td>
                {handleEmptyValue(invoicingData?.reconciledDocumentNumberLoan)}
              </td>
              <td>{handleEmptyValue(invoicingData?.airlineName)}</td>
              <td>
                {handleEmptyValue(invoicingData?.reconciledReferenceLoan)}
              </td>
              <td>
                {dayjs(invoicingData?.reconciledPostingDateLoan).format(
                  DATE_FORMAT
                )}
              </td>
              <td>{handleEmptyValue(invoicingData?.paymentMethod)}</td>
              <td>
                {formatToPositiveValue(invoicingData?.reconciledAmountLoan)}
              </td>
              <td>Airline Payment</td>
              <td>
                {handleEmptyValue(
                  invoicingData?.reconciledClientInvoiceRefLoan
                )}
              </td>
              <td>Cleared</td>
              <td className="overflow-text">
                {handleEmptyValue(invoicingData?.reconciliationFileNameLoan)}
              </td>
            </tr>
            <tr key={2}>
              <td>{2}</td>
              <td>{handleEmptyValue(invoicingData?.clientAccountNumber)}</td>
              <td>{handleEmptyValue(invoicingData?.materialPersonal)}</td>
              <td>{handleEmptyValue(invoicingData?.accountCode)}</td>
              <td>
                {handleEmptyValue(
                  invoicingData?.reconciledDocumentNumberPersonal
                )}
              </td>
              <td>{handleEmptyValue(invoicingData?.airlineName)}</td>
              <td>
                {handleEmptyValue(invoicingData?.reconciledReferencePersonal)}
              </td>
              <td>
                {dayjs(invoicingData?.reconciledPostingDatePersonal).format(
                  DATE_FORMAT
                )}
              </td>
              <td>{handleEmptyValue(invoicingData?.paymentMethod)}</td>
              <td>
                {formatToPositiveValue(invoicingData?.reconciledAmountPersonal)}
              </td>
              <td>Airline Payment</td>
              <td>
                {handleEmptyValue(
                  invoicingData?.reconciledClientInvoiceRefPersonal
                )}
              </td>
              <td>Cleared</td>
              <td className="overflow-text">
                {handleEmptyValue(
                  invoicingData?.reconciliationFileNamePersonal
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoicingIATAPaymentRecieptTable;
